<div class="container-fluid contact pt-5">
    <div class="backgroundAbout">
        <div class="backgroundAboutRight">
            <div class="row pb-5 mb-5">
                <div class="col-sm-5 align-self-center">
                    <h2>Contact Us</h2>
                    <p class="mb-5">
                        You can use the contact form to leave a question or an
                        inquiry and if appropriate, we will get back to you
                        within a business day.
                    </p>
                    <div class="d-flex">
                        <i class="fa-solid fa-location-dot"></i>
                        <p class="pl-2">Location goes here</p>
                    </div>
                    <div class="d-flex pt-3">
                        <i class="fa-solid fa-envelope-open"></i>
                        <p class="pl-2">example@beyondi.co</p>
                    </div>
                </div>
                <div class="col-sm pt-4">
                    <nb-card size="giant">
                        <nb-card-body>
                            <h3>You can reach us anytime</h3>
                            <form
                                method="POST"
                                [formGroup]="contactForm"
                                class="pt-3"
                            >
                                <div class="form-group">
                                    <p>Name</p>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="name"
                                        formControlName="name"
                                    />

                                    <p>Email</p>
                                    <input
                                        type="email"
                                        class="form-control"
                                        id="email"
                                        formControlName="email"
                                    />

                                    <p>Subject</p>
                                    <select
                                        class="form-control"
                                        id="subject"
                                        formControlName="subject"
                                    >
                                        <option value="Help">Help</option>
                                        <option value="GeneralMessage">
                                            General message
                                        </option>
                                        <option value="IdoApplication">
                                            Ido application
                                        </option>
                                        <option value="BusinessProposal">
                                            Business proposal
                                        </option>
                                    </select>

                                    <p>Message</p>
                                    <textarea
                                        class="form-control"
                                        id="message"
                                        formControlName="message"
                                        style="resize: none"
                                    ></textarea>

                                    <ngx-recaptcha2
                                        id="recaptcha"
                                        #captchaElem
                                        [siteKey]="siteKey"
                                        formControlName="recaptcha"
                                    >
                                    </ngx-recaptcha2>
                                </div>
                            </form>
                        </nb-card-body>
                        <div class="d-flex justify-content-center">
                            <button
                                class="btn btnMiddle"
                                nbButton
                                status="primary"
                                style="position: absolute"
                                [disabled]="!this.contactForm.valid"
                                (click)="sendContactForm()"
                            >
                                Send
                            </button>
                        </div>
                    </nb-card>
                </div>
            </div>
        </div>
    </div>
</div>
